define([
    "models/system/field",
    "models/system/model",
    "models/system/datasource",
    "models/system/commonView"
], function (Field, AbstractTableModel, Datasource, CommonView) {

    var endpoint = "SysParameter";

    var modelFields = [
        {
            name: "sysparameter_id",
            header: APPLOCALE.sysparam.table.idParam,
            keyField: true,
            viewLevel: 10,
            showInGrid: true
        },
        {name: "project_id", header: APPLOCALE.sysparam.table.projectId, viewLevel: 10, showInGrid: true},
        {name: "enterprise_id", header: APPLOCALE.sysparam.table.enterpriseId, viewLevel: 10, showInGrid: true},
        {name: "terminal_id", header: APPLOCALE.sysparam.table.terminalId, viewLevel: 10, showInGrid: true},
        {
            name: "obj_name", header: APPLOCALE.enterprise.table.name,
            label: APPLOCALE.sysparam.table.entityName,
            invalidMessage: APPLOCALE.errors.errorValidateEmptyForm,
            view: "text",
            disabled: true,
            showInForm: true
        },
        {
            name: "sp_name", header: APPLOCALE.sysparam.table.name,
            required: true,
            label: APPLOCALE.sysparam.table.name,
            invalidMessage: APPLOCALE.errors.errorValidateEmptyForm,
            view: "text",
            sort: "string",
            showInForm: true, showInGrid: true
        },
        {
            name: "sp_type", header: APPLOCALE.sysparam.table.spType, type: "toggle", toggleName: "paramtype",
            view: "combo",
            label: APPLOCALE.sysparam.table.spType,
            id: "paramTypeSelector",
            sort: "string",
            invalidMessage: APPLOCALE.errors.errorValidateEmptyForm,
            required: true,
            on: {
                onChange: function(newv) {
                    showHideParam(newv);
                }
            },
            options: {
                view: "suggest",
                body: {
                    view: "list",
                    name: "paramType",
                    on: {
                        onAfterSelect: function (id) {
                            var selItem = this.getSelectedItem();
                            showHideParam(selItem.id);
                        },
                        onBeforeLoad: function () {
                            var curForm,
                                curElements;

                            if ($$(view._insertFormId))
                                curForm = $$(view._insertFormId);
                            else
                                curForm = $$(view._updateFormId);
                            curElements = curForm.elements;
                            curElements.sp_valnum.hide();
                            curElements.sp_valstr.hide();

                            if (view._formCreationValues) {
                                switch (view._formCreationValues.sp_type) {
                                    case '1010':
                                        curElements.sp_valnum.hide();
                                        curElements.sp_valstr.show();
                                        curElements.sp_valnum.setValue("");
                                        break;
                                    case '1020':
                                        curElements.sp_valnum.show();
                                        curElements.sp_valstr.hide();
                                        curElements.sp_valstr.setValue("");
                                        break;
                                }
                            }
                        }
                    }
                }
            },
            showInForm: true, showInGrid: true
        },
        {
            name: "sp_valnum", header: APPLOCALE.sysparam.table.spValnum,
            id: "spValNum",
            required: true,
            label: APPLOCALE.sysparam.table.spValnum,
            invalidMessage: APPLOCALE.errors.errorValidateNumericParam,
            view: "text",
            showInForm: true, showInGrid: true
        },
        {
            name: "sp_valstr", header: APPLOCALE.sysparam.table.spValstr,
            id: "spValStr",
            required: true,
            label: APPLOCALE.sysparam.table.spValstr,
            invalidMessage: APPLOCALE.errors.errorValidateEmptyForm,
            view: "text",
            showInForm: true, showInGrid: true
        }
    ];

    var rules = {
        "sp_name": function(value){ return webix.rules.isNotEmpty(value) && value.length > 0 && value[0] !== " ";},
        "sp_valnum": function (value) {
            return value < 100000 && (value !== "") && value[0] !== " " ;
        },
        "sp_valstr": function(value){ return webix.rules.isNotEmpty(value) && value.length > 0 && value[0] !== " ";},
        "sp_type": function(value){ return webix.rules.isNotEmpty(value) && value.length > 0 && value[0] !== " ";},
    };

    var model = new AbstractTableModel("SysParam", modelFields, endpoint, rules);

    var dataSource = new Datasource(model);

    var view = new CommonView(dataSource);

    var showHideParam = function (valType) {
        switch (valType) {
            case '1010':
                $$('spValNum').hide();
                $$('spValStr').show();
                $$('spValNum').setValue("");
                break;
            case '1020':
                $$('spValNum').show();
                $$('spValStr').hide();
                $$('spValStr').setValue("");
                break;
        }
    };

    return {
        getModel: function () {
            return model;
        },
        getCleanModel: function () {
            return new AbstractTableModel("SysParam", modelFields, endpoint, rules);
        },
        getDatasource: function () {
            return dataSource;
        },
        getCommonViewModel: function () {
            return view;
        }
    };
});
